<script>
  import { createEventDispatcher, onMount } from 'svelte';
  const dispatch = createEventDispatcher();
  
  export let init = new Date();
  export let item = {};
  export let hour_forecast_group_size = 6;
  export let expanded = false;
  
  let time = new Date();
  
  function dateForHumans(t) {
    let day, d = new Date(t);
    switch(d.getDay()) {
      case 0: day = "Neděle"; break;
      case 1: day = "Pondělí";break;
      case 2: day = "Úterý";break;
      case 3: day = "Středa";break;
      case 4: day = "Čtvrtek";break;
      case 5: day = "Pátek";break;
      case 6: day = "Sobota";break;
    }
  
     return day + "\t" + d.toLocaleDateString('cs-CZ');
  }
  
  function situationIcon(cloud) {
    if (!cloud || cloud < 20)
      return "wi-day-sunny";
    else if (cloud >= 20 && cloud < 50)
      return "wi-day-sunny-overcast";
    else if (cloud >= 50 && cloud < 77)
      return "wi-cloud";
    else if (cloud >= 77)
      return "wi-cloudy";
  }
  
  function togglePanelVisibility() {
    dispatch("toggle")
  }
  
  onMount(() => {
    time = new Date(item.time);
  })
</script>
{#if time.getHours() == 0}
<div class='d-flex flex-row justify-content-end mt-3 px-1 pntr rounded-bottom-0' on:click='{togglePanelVisibility}'>
<div class='pt-1 pl-4 mb-0 mt-1 text-left text-info align-middle w-100 badge badge-light'>
{@html dateForHumans(time)}
</div>
</div>
{/if}
{#if time.getHours() % 6 == 3}
<div class='d-flex flex-row justify-content-start px-4 py-2 mx-1 bg-light gradw-{time.getHours()}'>
<small class='text-left w-33 m-0'>
{("0" + (time.getHours()) % 24).slice(-2)}
<small>
<i class='far fa-clock text-muted'></i>
</small>
</small>
<div class='h6 text-center w-33 m-0'>
<i class='d-inline-block mr-2 wi {situationIcon(item.cloud)}'></i>
{#if item.precip_mm > 0 }
<br>
<small>
{item.precip_mm}
<small class='text-muted'>mm</small>
</small>
{/if}
</div>
<div class='h6 text-right w-33 m-0'>
<strong>{item.temp_c}</strong>
<small class='text-muted'>°C</small>
</div>
</div>
{/if}

